import React from 'react';

import { SingleLayout, UpgradeAccount } from 'components';

/**
 * 升級專業版頁面
 */

export const UpgradeAccountPage = () => {
  return (
    <SingleLayout>
      <UpgradeAccount />
    </SingleLayout>
  );
};
